import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.scss';
import App from './App';
import { MessagePage } from './pages/MessagePage';
import { Button } from './components/Button';
import { ProductType } from './api/model/common';
import { strings } from './strings/strings';
import config from './config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import packageJson from "../package.json";

console.info(`${packageJson.name} version: ${packageJson.version}`);

if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV,
        release: process.env.REACT_APP_SENTRY_RELEASE ?? packageJson.version,
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    });
} else {
    console.warn('[Sentry] REACT_APP_SENTRY_DSN not configured. Sentry will not be active.');
}

const CrashFallback = () => (
    <MessagePage homeUrl={config.ARX_URL} type={ProductType.TRAVEL}>
        <h1>{strings.crashFallbackTitle}</h1>
        <p>{strings.crashFallbackDescription}</p>
        <Button label={strings.toMainPage} onClickListener={() => window.location.replace(config.ARX_URL)} />
    </MessagePage>
);

ReactDOM.render(
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
        <App />
    </Sentry.ErrorBoundary>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
